export const RECOVERY_EVENT = 'app-recovery-required'

export function emitRecoveryRequested(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(RECOVERY_EVENT))
  }
}

export async function runDbOperation<T>(operation: () => Promise<T>): Promise<T> {
  try {
    return await operation()
  } catch (error) {
    emitRecoveryRequested()
    throw error
  }
}
